import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useDeletePessoaFormaPagamento() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const deletePessoaFormaPagamento = useCallback(
        (pessoaId: string, id: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/pessoa/${pessoaId}/forma-pagamento/${id}`,
                method: 'DELETE',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        deletePessoaFormaPagamento,
    };
}
